class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onOpeningTransitionEnd = () => {
      if (!this.notification.classList.contains('active') || this.notification.contains(document.activeElement)) return;
      if (document.activeElement === this.openingActiveElement || document.activeElement === document.body) {
        this.notification.focus();
      }
    };

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.notification.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
    });
  }

  open() {
    this.openingActiveElement = document.activeElement;
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      this.onOpeningTransitionEnd,
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close(restoreFocus = true) {
    this.notification.classList.remove('active');
    this.notification.removeEventListener('transitionend', this.onOpeningTransitionEnd);
    document.body.removeEventListener('click', this.onBodyClick);

    if (restoreFocus) this.activeElement?.focus();
  }

  disconnectedCallback() {
    this.close(false);
  }

  renderContents(parsedState, { open = true } = {}) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    if (open) this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
